var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bordered"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-table-simple', {
    attrs: {
      "borderless": ""
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "17%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "26%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "7%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  })]), _c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("Artikelnr.")]), _c('b-th', [_vm._v("Artikelnaam")]), _c('b-th', [_vm._v("Aantal")]), _c('b-th', [_vm._v("Stuksprijs")]), _c('b-th', [_vm._v("Bezorgmethode")]), _c('b-th', [_vm._v("Beoogde leverdatum")])], 1)], 1), _c('b-tbody', [_c('b-tr', [_c('b-td', [_c('b-input', {
    attrs: {
      "placeholder": "Artikelnr.",
      "pattern": "\\d+",
      "required": "",
      "size": "sm",
      "readonly": _vm.validated,
      "plaintext": _vm.validated
    },
    model: {
      value: _vm.product_identifier,
      callback: function ($$v) {
        _vm.product_identifier = $$v;
      },
      expression: "product_identifier"
    }
  })], 1), _c('b-td', [_c('b-input', {
    attrs: {
      "placeholder": !_vm.validationEnabled ? 'Artikelnaam' : '',
      "required": "",
      "size": "sm",
      "readonly": _vm.validated || _vm.validationEnabled,
      "plaintext": _vm.validated || _vm.validationEnabled
    },
    model: {
      value: _vm.product_name,
      callback: function ($$v) {
        _vm.product_name = $$v;
      },
      expression: "product_name"
    }
  })], 1), _c('b-td', [_c('b-input', {
    attrs: {
      "type": "number",
      "size": "sm",
      "min": "1",
      "required": "",
      "readonly": _vm.validated,
      "plaintext": _vm.validated
    },
    model: {
      value: _vm.quantity,
      callback: function ($$v) {
        _vm.quantity = $$v;
      },
      expression: "quantity"
    }
  })], 1), _c('b-td', [_vm._v(" €  "), _c('b-input', {
    staticClass: "d-inline-block",
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "type": "number",
      "size": "sm",
      "min": "0",
      "readonly": true,
      "plaintext": true
    },
    model: {
      value: _vm.price,
      callback: function ($$v) {
        _vm.price = $$v;
      },
      expression: "price"
    }
  })], 1), _c('b-td', [_c('small', [_vm._v("Wordt overgenomen van de huidige order")])]), !_vm.validated ? _c('b-td', [_c('b-input', {
    attrs: {
      "type": "date",
      "required": "",
      "size": "sm",
      "min": _vm.tomorrow,
      "placeholder": "YYYY-MM-DD",
      "readonly": _vm.validated,
      "plaintext": _vm.validated
    },
    model: {
      value: _vm.delivery_date,
      callback: function ($$v) {
        _vm.delivery_date = $$v;
      },
      expression: "delivery_date"
    }
  })], 1) : _c('b-td', {
    domProps: {
      "textContent": _vm._s(_vm.delivery_date)
    }
  })], 1)], 1)], 1), _c('p', {
    staticClass: "text-right"
  }, [_c('product-stock-status', {
    key: `${_vm.product_identifier}_${_vm.quantity}`,
    staticClass: "d-inline-block mr-4",
    attrs: {
      "product-identifier": _vm.product_identifier,
      "quantity": _vm.quantity
    }
  }), _c('b-button', {
    attrs: {
      "variant": !_vm.validationEnabled || _vm.validated ? 'success' : 'primary',
      "type": "submit",
      "disabled": !_vm.isSubmittable || _vm.isSubmitting
    }
  }, [_vm.isSubmitting ? _c('span', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('span', [_vm._v(_vm._s(!_vm.validationEnabled || _vm.validated ? 'Toevoegen' : 'Valideer aanvraag'))])])], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }